module.exports = __webpack_public_path__ + "static/media/animation.f4d0823d.svg";